import { OpenLevelNameEnum } from "common/enums/OpenLevelEnum";
import { useCallback, useEffect, useState } from "react";
import { OpenLevelSelectDialogProps } from "./interfaces";

export const useOpenLevelSelectDialogHooks = (
  props: OpenLevelSelectDialogProps
) => {
  const [openLevels, setOpenLevels] = useState<
    OpenLevelSelectDialogProps["openLevels"]
  >(props.openLevels);
  const [busy, setBusy] = useState(false);

  const onOpenLevelClick = useCallback((openLevel: OpenLevelNameEnum) => {
    setOpenLevels((prev) => {
      if (prev.includes(openLevel)) {
        return prev.filter((v) => v !== openLevel).slice();
      } else {
        return [...prev, openLevel];
      }
    });
  }, []);

  const onOkClick = useCallback(() => {
    // OKボタンクリック時
    setBusy(true);
  }, []);

  useEffect(() => {
    setTimeout(() => setOpenLevels(props.openLevels), 0);
  }, [props.openLevels]);

  useEffect(() => {
    if (busy) {
      props.onOkClick(openLevels);
      setTimeout(() => setBusy(false), 0);
    }
  }, [busy, openLevels, props]);

  return { openLevels, busy, onOpenLevelClick, onOkClick } as const;
};
